import PurchaseOrders from './PurchaseOrders';

export default PurchaseOrders;
